export const normalizeAssetChart = (chart = []) =>
  (Array.isArray(chart) ? chart : [])
    .map((item) => {
      const value = Number(item?.value) || 0;
      const percent = Number(item?.percent) || 0;

      return {
        serviceId: item?.serviceId || "",
        label: item?.label || "Khác",
        value,
        percent,
      };
    })
    .filter((item) => item.value > 0);

export const buildAssetReportRows = (chart = []) =>
  normalizeAssetChart(chart).map((item, index) => ({
    id: item.serviceId || `${item.label}-${index}`,
    index: index + 1,
    serviceName: item.label,
    total: item.value,
    percent: item.percent,
  }));

export const getAssetReportSummary = (chart = []) => {
  const normalizedChart = normalizeAssetChart(chart);
  const totalAssets = normalizedChart.reduce((sum, item) => sum + item.value, 0);

  return {
    totalAssets,
    totalServices: normalizedChart.length,
  };
};
